import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

interface LovedOneCardProps {
  lovedOne: {
    _id: string
    name: string
    phoneNumber: string
    profilePhotoUrl?: string
  }
  callsThisWeek: number
  className?: string
}

/**
 * LovedOneCard - Bank-style card for loved ones list view
 * Displays name, photo, phone, and weekly call count
 */
export function LovedOneCard({ lovedOne, callsThisWeek, className }: LovedOneCardProps) {
  const { t } = useTranslation()

  const cardStyles: React.CSSProperties = {
    backgroundColor: '#fff',
    borderRadius: '12px',
    padding: '1.25rem',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
    textDecoration: 'none',
    color: 'inherit',
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    minHeight: '44px',
    transition: 'box-shadow 0.2s, transform 0.2s',
  }

  const avatarStyles: React.CSSProperties = {
    width: '56px',
    height: '56px',
    borderRadius: '50%',
    backgroundColor: '#e5e7eb',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.5rem',
    color: '#6b7280',
    overflow: 'hidden',
    flexShrink: 0,
  }

  const avatarImgStyles: React.CSSProperties = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  }

  const infoStyles: React.CSSProperties = {
    flex: 1,
    minWidth: 0,
  }

  const nameStyles: React.CSSProperties = {
    fontSize: '18px',
    fontWeight: 600,
    color: '#1a1a1a',
    marginBottom: '0.25rem',
  }

  const phoneStyles: React.CSSProperties = {
    fontSize: '14px',
    color: '#6b7280',
  }

  const metricsStyles: React.CSSProperties = {
    textAlign: 'right',
    flexShrink: 0,
  }

  const callCountStyles: React.CSSProperties = {
    fontSize: '1.5rem',
    fontWeight: 700,
    color: '#1a1a1a',
  }

  const callLabelStyles: React.CSSProperties = {
    fontSize: '12px',
    color: '#9ca3af',
  }

  const arrowStyles: React.CSSProperties = {
    color: '#9ca3af',
    fontSize: '1.25rem',
    marginLeft: '0.5rem',
  }

  const callLabel = callsThisWeek === 1 ? t('dashboard.callThisWeek') : t('dashboard.callsThisWeek')

  return (
    <Link to={`/dashboard/${lovedOne._id}`} style={cardStyles} className={className}>
      <div style={avatarStyles}>
        {lovedOne.profilePhotoUrl ? (
          <img src={lovedOne.profilePhotoUrl} alt={lovedOne.name} style={avatarImgStyles} />
        ) : (
          lovedOne.name.charAt(0).toUpperCase()
        )}
      </div>

      <div style={infoStyles}>
        <div style={nameStyles}>{lovedOne.name}</div>
        <div style={phoneStyles}>{lovedOne.phoneNumber}</div>
      </div>

      <div style={metricsStyles}>
        <div style={callCountStyles}>{callsThisWeek}</div>
        <div style={callLabelStyles}>{callLabel}</div>
      </div>

      <span style={arrowStyles}>→</span>
    </Link>
  )
}
